module.exports = __webpack_public_path__ + "img/subProcess.1e340068.svg";